import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/';

import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { KanziRestClientService } from '@kanzi-apes/kanzi-rest-api';
import {
  aditionalHeadersModel,
  DashboardListModel,
  FlightReportListModel,
} from '@kanzi-apes/kanzi-models';

@Injectable({
  providedIn: 'root',
})
export class KanziAnalyticsReportsService {
  private qsAPIUrlCommon = this.envService.environment?.qsApiUrlCommon;
  private qsAPIUrlCommonWMS = this.envService.wmsEnvironment?.qsApiUrlCommon;
  private flightReportUrl = this.envService.environment?.flightReportApiUrl;
  private flightReportToken: string;

  constructor(
    private apiClientService: KanziRestClientService,
    private envService: EnvironmentService
  ) {
    this.flightReportToken = envService.environment?.tokenFlightReport ?? '';
  }

  /**
   *
   * @param tenantId {string} - Tenant ID to fetch the report list for
   * @returns {Observable<DashboardListModel>} - An observable containing the list of dashboards
   * This method retrieves a list of dashboards for a specific tenant.
   */
  getReportList(
    tenantId: string,
    isWMS = false
  ): Observable<DashboardListModel> {
    const url = isWMS
      ? `${this.qsAPIUrlCommonWMS}list-dashboards/${tenantId}`
      : `${this.qsAPIUrlCommon}list-dashboards/${tenantId}`;
    return this.apiClientService.get<DashboardListModel>(
      url,
      null,
      'Error al traer el listado de reportes.'
    );
  }

  getFlightReport(): Observable<FlightReportListModel> {
    const url = `${this.flightReportUrl}`;
    const additionalHeaders: aditionalHeadersModel = {
      'x-api-key': this.flightReportToken,
    };

    return this.apiClientService.getReports<FlightReportListModel>(
      url,
      null,
      'Error al traer el reporte.',
      additionalHeaders
    );
  }

  getEmbedReport(
    tenantId: string,
    dashboardName: string | null = null,
    isWMS = false
  ): Observable<any> {
    const url = isWMS
      ? `${this.qsAPIUrlCommonWMS}embed-qs-dashboard?mode=getUrl&dashboardName=${dashboardName}&tenantId=${tenantId}`
      : `${this.qsAPIUrlCommon}embed-qs-dashboard?mode=getUrl&dashboardName=${dashboardName}&tenantId=${tenantId}`;
    return this.apiClientService.get<any>(
      url,
      null,
      'Error al traer el reporte.'
    );
  }
}
